'use client'

import 'simplebar-react/dist/simplebar.min.css'
import SimpleBar from 'simplebar-react'

interface ScrollbarWrapperProps {
	children: React.ReactNode
	className?: string
	style?: React.CSSProperties
}

export function ScrollbarWrapper({ children, className, style }: ScrollbarWrapperProps) {
	return <SimpleBar className={className} style={style}>{children}</SimpleBar>
}
